module.exports = __webpack_public_path__ + "img/gestacao-com-a-carreira.ed1d8343.svg";